import {
  EarningsInsight,
  EarningsInsightRecapResponse,
  EarningsItemBase,
} from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TextSection } from '~/components/text-section/TextSection';
import { POSTHOG_TRACKING_SOURCES } from '~/services/tracking/posthog/constants';
import { useFlags } from '~/stores/use-flags/useFlags';
import { EarningsInsightPill } from '~/widgets/earnings-insight-drawer/earnings-insight-widget/components/earnings-insight-pill/EarningsInsightPill';
import { PublishedDate } from '~/widgets/earnings-insight-drawer/earnings-insight-widget/components/published-date/PublishedDate';

import { EarningsHighlightsTable } from '../earnings-highlights-table/EarningsHighlightsTable';
import styles from './RecapOverview.module.scss';

interface RecapOverviewProps {
  title: string;
  activeEntityTag: string;
  earningsData: EarningsItemBase;
  recapData: EarningsInsightRecapResponse;
  recapEarningsInsight?: EarningsInsight;
}

export const RecapOverview = ({
  title,
  activeEntityTag,
  earningsData,
  recapData,
  recapEarningsInsight,
}: RecapOverviewProps) => {
  const isUniversalDrawerEnabled = useFlags(state =>
    state.getFeatureFlagState('universal_drawer')
  );
  const { t } = useTranslation(['earnings']);

  return (
    <div className={styles.container}>
      <div className={styles.pillWrapper}>
        {isUniversalDrawerEnabled && recapEarningsInsight && (
          <EarningsInsightPill
            entityTag={activeEntityTag}
            earningsInsight={recapEarningsInsight}
            isClickable={false}
            isPreview={false}
            source={POSTHOG_TRACKING_SOURCES.EARNINGS_INSIGHT_DRAWER}
          />
        )}
        <PublishedDate
          publishedAt={recapData.created_at}
          updatedAt={recapData.updated_at}
          isPreview={false}
          fiscalYear={earningsData.fiscal_year}
          fiscalPeriod={earningsData.fiscal_period}
          releasedAt={earningsData.reporting_date}
        />
      </div>
      <p className={styles.title}>{title}</p>
      <EarningsHighlightsTable earningsData={earningsData} />
      <div className={styles.keyMetricsWrapper}>
        <TextSection
          title={t('earnings:earningsInsight.drawer.earningsRecap.keyMetrics')}
          variant={'secondary'}
          useBulletPoints={false}
          textContent={[recapData.key_metrics]}
        />
      </div>
      <TextSection
        title={t(
          'earnings:earningsInsight.drawer.earningsRecap.guidanceUpdate'
        )}
        variant={'secondary'}
        useBulletPoints={false}
        textContent={[recapData.guidance_update]}
      />
    </div>
  );
};
